import React, { useState, useEffect } from 'react';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import styles from './AnalyticsDashboard.module.css';

const AnalyticsDashboard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [events, setEvents] = useState([]);
  const { trackEvent, trackButtonClick, trackConversion, isTrackingEnabled } = useGoogleAnalytics();

  // Surveiller les événements dataLayer
  useEffect(() => {
    if (!window.dataLayer) return;

    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function(...args) {
      // Ajouter l'événement à notre liste
      setEvents(prev => [{
        timestamp: new Date().toLocaleTimeString(),
        data: args[0],
        id: Math.random().toString(36).substr(2, 9)
      }, ...prev.slice(0, 49)]); // Garder seulement les 50 derniers

      return originalPush.apply(this, arguments);
    };

    return () => {
      window.dataLayer.push = originalPush;
    };
  }, []);

  const handleTestEvent = (eventType) => {
    switch(eventType) {
      case 'click':
        trackButtonClick('test_button', 'debug_dashboard');
        break;
      case 'conversion':
        trackConversion('test_conversion', 100, 'EUR');
        break;
      case 'custom':
        trackEvent('test_custom_event', {
          event_category: 'debug',
          event_action: 'test',
          event_label: 'dashboard_test',
          custom_parameter: 'test_value'
        });
        break;
      default:
        break;
    }
  };

  const clearEvents = () => {
    setEvents([]);
  };

  if (process.env.REACT_APP_ENV === 'production') {
    return null; // Ne pas afficher en production
  }

  return (
    <>
      {/* Bouton flottant */}
      <div className={styles.floatingButton} onClick={() => setIsVisible(!isVisible)}>
        📊
      </div>

      {/* Dashboard */}
      {isVisible && (
        <div className={styles.dashboard}>
          <div className={styles.header}>
            <h3>Analytics Debug Dashboard</h3>
            <button className={styles.closeButton} onClick={() => setIsVisible(false)}>×</button>
          </div>

          <div className={styles.content}>
            {/* Status */}
            <div className={styles.section}>
              <h4>Status</h4>              <div className={styles.status}>
                <span className={`${styles.indicator} ${isTrackingEnabled ? styles.active : styles.inactive}`}>
                  {isTrackingEnabled ? '✓' : '✗'}
                </span>
                Tracking: {isTrackingEnabled ? 'Actif' : 'Inactif'}
              </div>
              <div className={styles.status}>
                <span className={`${styles.indicator} ${window.gtag ? styles.active : styles.inactive}`}>
                  {window.gtag ? '✓' : '✗'}
                </span>
                Google Analytics: {window.gtag ? 'Chargé' : 'Non chargé'}
              </div>
              <div className={styles.status}>
                <span className={`${styles.indicator} ${window.dataLayer && window.dataLayer.length > 0 ? styles.active : styles.inactive}`}>
                  {window.dataLayer && window.dataLayer.length > 0 ? '✓' : '✗'}
                </span>
                GTM DataLayer: {window.dataLayer && window.dataLayer.length > 0 ? 'Actif' : 'Inactif'}
              </div>
              <div className={styles.status}>
                <span className={`${styles.indicator} ${localStorage.getItem('cookieConsent') === 'accepted' ? styles.active : styles.inactive}`}>
                  {localStorage.getItem('cookieConsent') === 'accepted' ? '✓' : '✗'}
                </span>
                Consentement: {localStorage.getItem('cookieConsent') || 'Non défini'}
              </div>
            </div>

            {/* Test Events */}
            <div className={styles.section}>
              <h4>Test Events</h4>
              <div className={styles.testButtons}>
                <button onClick={() => handleTestEvent('click')}>Test Click</button>
                <button onClick={() => handleTestEvent('conversion')}>Test Conversion</button>
                <button onClick={() => handleTestEvent('custom')}>Test Custom</button>
              </div>
            </div>

            {/* Events Log */}
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <h4>Recent Events ({events.length})</h4>
                <button onClick={clearEvents} className={styles.clearButton}>Clear</button>
              </div>
              <div className={styles.eventsList}>
                {events.length === 0 ? (
                  <div className={styles.noEvents}>Aucun événement récent</div>
                ) : (
                  events.map(event => (
                    <div key={event.id} className={styles.eventItem}>
                      <div className={styles.eventTime}>{event.timestamp}</div>
                      <div className={styles.eventData}>
                        <strong>{event.data.event || 'Unknown Event'}</strong>
                        <pre>{JSON.stringify(event.data, null, 2)}</pre>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Configuration */}
            <div className={styles.section}>
              <h4>Configuration</h4>
              <div className={styles.config}>
                <div>GTM ID: {process.env.REACT_APP_GTM_ID || 'Non configuré'}</div>
                <div>GA ID: {process.env.REACT_APP_GA_MEASUREMENT_ID || 'Non configuré'}</div>
                <div>Environment: {process.env.REACT_APP_ENV || 'development'}</div>
                <div>Consent: {localStorage.getItem('cookieConsent') || 'Non défini'}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AnalyticsDashboard;
